<template>
  <Card>
    <CardHeader>
      <CardTitle>SMS Adapter Configuration</CardTitle>
      <CardAction>
        <Button variant="card-header-action" size="sm" @click="isSheetOpen = true">Edit</Button>
      </CardAction>
    </CardHeader>
    <CardContent>
      <dl class="grid grid-cols-1 gap-x-8 gap-y-8 sm:grid-cols-2">
        <div class="sm:col-span-1 space-y-2">
          <dt class="text-xs font-medium uppercase tracking-[0.08em] text-gray-500">Provider</dt>
          <dd class="min-h-6 text-sm text-gray-900">{{ config?.provider || '—' }}</dd>
        </div>
        <div class="sm:col-span-1 space-y-2">
          <dt class="text-xs font-medium uppercase tracking-[0.08em] text-gray-500">Status</dt>
          <dd class="min-h-6">
            <Badge :variant="statusBadge.variant">{{ statusBadge.text }}</Badge>
          </dd>
        </div>
        <div class="sm:col-span-1 space-y-2">
          <dt class="text-xs font-medium uppercase tracking-[0.08em] text-gray-500">Telnyx Phone Number</dt>
          <dd class="min-h-6 text-sm text-gray-900">{{ config?.telnyx_phone_number || '—' }}</dd>
        </div>
        <div class="sm:col-span-1 space-y-2">
          <dt class="text-xs font-medium uppercase tracking-[0.08em] text-gray-500">Telnyx Order ID</dt>
          <dd class="min-h-6 text-sm text-gray-900">{{ config?.telnyx_phone_number_order_id || '—' }}</dd>
        </div>
        <div class="sm:col-span-1 space-y-2">
          <dt class="text-xs font-medium uppercase tracking-[0.08em] text-gray-500">Requested Area Code</dt>
          <dd class="min-h-6 text-sm text-gray-900">{{ config?.requested_area_code || '—' }}</dd>
        </div>
      </dl>
    </CardContent>
  </Card>

  <EditSmsAdapterConfigSheet
    v-if="isSheetOpen && config"
    v-model:open="isSheetOpen"
    :config="config"
    :team-id="teamId"
    @saved="emit('saved')"
  />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { Card, CardAction, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import EditSmsAdapterConfigSheet from './EditSmsAdapterConfigSheet.vue';
import type { SmsAdapterConfig } from './types';

type Props = {
  config: SmsAdapterConfig | null;
  teamId: string;
};

const props = defineProps<Props>();
const emit = defineEmits<{ saved: [] }>();

const isSheetOpen = ref(false);

const statusBadge = computed(() => {
  const status = props.config?.status;
  if (status === 'active') return { variant: 'green' as const, text: 'active' };
  return { variant: 'red' as const, text: status || 'inactive' };
});
</script>
